import React, { useEffect, useState } from 'react';
import { Card, Grid, Paper, Typography } from '@mui/material';
import { AppContext } from '../../context/AppContext';
import BakeasyEmptyMsg from '../../components/common/BakeasyEmptyMsg';
import BakeasyHeaderLabel from '../../components/lables/BakeasyHeaderLabel';
import { BakeasyChip } from '../../components/common/BakeasyChip';
import { useLocation, useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import {
  BakeasyButton,
  BakeasyButtonUpdateShipping,
} from '../../components/buttons/BakeasyButton';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import {
  cancelOrder,
  clearOrdersState,
  downloadOrderDetails,
  fetchOrderById,
  modifyOrderStatus,
  ordersState,
  packedOrder,
  updateStoreDetails,
} from '../../redux_store/slices/ordersSlice';
import { preparePostalCode } from '../../utils/ValidationUtils';
import { showErrorSnackbar } from '../../redux_store/slices/snackbarSlice';
import dayjs, { Dayjs } from 'dayjs';
import * as Dropdown from '../../components/dropdowns/BakeasySelect';
import * as TextField from '../../components/textfields/BakeasyTextFields';
import BakeasyTextField from '../../components/textfields/BakeasyTextField';
import BakeasyDatePicker from '../../components/common/BakeasyDatePicker';
import BakeasyDivider from '../../components/common/BakeasyDivider';
import { BakeasyAppBar } from '../../components/common/BakeasyAppBar';
import BakeasySimpleTable from '../../components/tables/BakeasySimpleTable';
import BakeasyLinkButton from '../../components/buttons/BakeasyLinkButton';
import BakeasyLargeHeadingValue, {
  BakeasyLargeHeadingStatus,
} from '../../components/lables/BakeasyLargeHeadingValue';
import { orderDetailsTableHeaders } from '../../constants/TableHeaders';
import { BakeasyNotesLabelText } from '../../components/lables/BakeasyLabelText';
import { taxesState } from '../../redux_store/slices/taxesSlice';
import {
  BakeasyAutoCompleteCountry,
  BakeasyAutoCompleteShippingMethod,
  BakeasyAutoCompleteState,
  BakeasyAutoCompleteTax,
} from '../../components/dropdowns/BakeasyAutoComplete';
import i18n from '../../languages/languages';
import * as Regex from '../../constants/Regex';
import { shippingMethodsState } from '../../redux_store/slices/shippingMethodsSlice';
import {
  clearStatesState,
  fetchStates,
  statesState,
} from '../../redux_store/slices/statesSlice';
import {
  countryState,
  fetchCountries,
} from '../../redux_store/slices/countriesSlice';
import { RED_400 } from '../../constants/Colors';

export const OrderDetails = (props: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  let myContext = React.useContext(AppContext);

  const [ordersList, setOrdersList] = useState<any[]>([]);
  const [splitOrders, setSplitOrders] = useState<any>([]);

  const [status, setStatus] = useState<string>('');
  const [supplierName, setSupplierName] = useState<any>();

  const [poNumber, setPoNumber] = useState<any>();
  const [orderBy, setOrderBy] = useState<any>();
  const [orderId, setOrderId] = useState<any>();
  const [latestSupplierNote, setLatestSupplierNote] = useState<any>(undefined);
  const [latestStoreNote, setLatestStoreNote] = useState<any>(undefined);
  const [requestedDeliveryDate, setRequestedDeliveryDate] =
    useState<Dayjs | null>(null);
  const [selectedPriority, setSelectedPriority] = useState<any>('');
  const [selectedShipTo, setSelectedShipTo] = useState<any>('');
  const [shipToName, setShipToName] = useState<any>('');
  const [shipToCompanyName, setShipToCompanyName] = useState<any>('');
  const [shipToAddress, setShipToAddress] = useState<any>('');
  const [shipToCity, setShipToCity] = useState<any>('');
  const [shipToPostCode, setShipToPostCode] = useState<any>('');
  const [shipToCountry, setShipToCountry] = useState<any>('');
  const [shipToState, setShipToState] = useState<any>('');

  const [selectedPreferredShippingMethod, setSelectedPreferredShippingMethod] =
    useState<any>('');
  const [selectedShippingCharge, setSelectedShippingCharge] = useState<any>('');
  const [selectedShippingCalculation, setSelectedShippingCalculation] =
    useState<any>('');
  const [shippingCharges, setShippingCharges] = useState<any>('');

  const [selectedTaxRate1, setSelectedTaxRate1] = useState<any>('');
  const [selectedTaxRate2, setSelectedTaxRate2] = useState<any>('');

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<any>('');
  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState<any>('');
  const [total, setTotal] = useState<any>([{}]);
  const [note, setNote] = useState('');
  const [isView, setIsView] = useState<boolean>(false);

  let { selectedValue } = useAppSelector(ordersState);
  let _shippingMethodsState = useAppSelector(shippingMethodsState);
  let _taxesState = useAppSelector(taxesState);
  let _countryState = useAppSelector(countryState);
  let _statesState = useAppSelector(statesState);
  useEffect(() => {
    fetchData(location?.state?.id);
    setOrderId(location?.state?.orderId);
  }, []);

  const fetchData = async (id: any) => {
    try {
      await dispatch(fetchOrderById({ id: id }));
      await dispatch(fetchCountries({ page: 1, limit: 5, search: '' }));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
    }
  };

  function openSupplierNotesDialog(
    isEdit: any,
    from: string,
    fetchMethod: any
  ) {
    return myContext.setDialog({
      open: true,
      dialogContent: {
        pageName: 'supplierNotesHistory',
        params: { isEdit, from, fetchMethod },
        onBack: async () => {},
      },
    });
  }

  function getRegexPatternForPostalCode(country: string): RegExp {
    if (country === 'Canada') {
      return Regex.canadaPostCode;
    } else if (country === 'USA') {
      return Regex.usaPostCode;
    }
    return Regex.canadaPostCode;
  }

  function getMaxLengthForPostalCode(country: string): number {
    if (country === 'Canada') {
      return 7;
    } else if (country === 'USA') {
      return 10;
    }
    return 7;
  }

  async function setShipToData(shipToValue: string, data: any) {
    switch (shipToValue) {
      case 'Pickup':
        setShipToName(
          data?.shipToInfo?.name || data?.storeInfo?.shipToInfo?.name
        );
        setShipToCompanyName(
          data?.shipToInfo?.companyName ||
            data?.storeInfo?.shipToInfo?.companyName
        );
        setShipToAddress(
          data?.shipToInfo?.companyAddress ||
            data?.storeInfo?.shipToInfo?.companyAddress
        );
        setShipToCity(
          data?.shipToInfo?.city || data?.storeInfo?.shipToInfo?.city
        );
        setShipToState(
          data?.shipToInfo?.state
            ? { stateName: data?.shipToInfo?.state }
            : data?.storeInfo?.shipToInfo?.state
              ? { stateName: data?.storeInfo?.shipToInfo?.state }
              : null
        );
        setShipToCountry(
          data?.shipToInfo?.country
            ? { countryName: data?.shipToInfo?.country }
            : data?.storeInfo?.shipToInfo?.country
              ? { countryName: data?.storeInfo?.shipToInfo?.country }
              : null
        );

        setShipToPostCode(
          data?.shipToInfo?.zipCode || data?.storeInfo?.shipToInfo?.zipCode
        );
        break;
      case 'Other':
        clearShipTo();
        break;
      case 'Store':
        setShipToName(data?.storeInfo?.shipToInfo?.name);
        setShipToCompanyName(data?.storeInfo?.shipToInfo?.companyName);
        setShipToAddress(data?.storeInfo?.shipToInfo?.companyAddress);
        setShipToCity(data?.storeInfo?.shipToInfo?.city);
        // setShipToState(data?.storeInfo?.shipToInfo?.state);

        setShipToState(
          data?.storeInfo?.shipToInfo?.state
            ? { stateName: data?.storeInfo?.shipToInfo?.state }
            : data?.storeInfo?.shipToInfo?.state
              ? { stateName: data?.storeInfo?.shipToInfo?.state }
              : null
        );
        setShipToCountry(
          data?.storeInfo?.shipToInfo?.country
            ? { countryName: data?.storeInfo?.shipToInfo?.country }
            : data?.storeInfo?.shipToInfo?.country
              ? { countryName: data?.storeInfo?.shipToInfo?.country }
              : null
        );

        // setShipToCountry(data?.storeInfo?.shipToInfo?.country);
        // const countryObj = _countryState?.value?.data?.find(
        //   (c: any) =>
        //     c?.countryName?.toLowerCase() ===
        //     data?.storeInfo?.shipToInfo?.country?.toLowerCase()
        // );

        // if (countryObj) {
        //   setShipToCountry(countryObj);

        //   // 🔥 2. LOAD STATES THEN SET STATE OBJECT
        //   const statesList = (await handleShipToCountrySelect(
        //     countryObj
        //   )) as unknown as any[];

        //   const stateObj = statesList?.find(
        //     (s: any) =>
        //       s?.stateName?.toLowerCase() ===
        //       data?.storeInfo?.shipToInfo?.state?.toLowerCase()
        //   );

        //   setShipToState(stateObj);
        // }
        setShipToPostCode(data?.storeInfo?.shipToInfo?.zipCode);
        break;
      default:
        clearShipTo();
        break;
    }
  }

  function clearShipTo() {
    setShipToName('');
    setShipToCompanyName('');
    setShipToAddress('');
    setShipToCity('');
    setShipToState('');
    setShipToCountry('');
    setShipToPostCode('');
  }

  function openStoreNotesDialog(isEdit: any, from: string) {
    return myContext.setDialog({
      open: true,
      dialogContent: {
        pageName: 'storeNotesHistory',
        params: { isEdit, from },
        onBack: async () => {},
      },
    });
  }

  useEffect(() => {
    if (selectedValue) {
      setData(selectedValue);
    }
  }, [selectedValue]);

  function setData(data: any) {
    setSupplierName(data?.supplierName);
    setStatus(data?.status);
    setPoNumber(data?.poNumber);
    setOrderBy(data?.orderBy);
    setNote(data?.note);
    setRequestedDeliveryDate(data?.requestedDeliveryDate);
    setSelectedPriority(
      data?.priority
        ? i18n.language === 'fr'
          ? 'Oui'
          : 'Yes'
        : i18n.language === 'fr'
          ? 'Non'
          : 'No'
    );

    setSelectedShipTo(data?.shipTo);
    setShipToName(data?.shipToInfo?.name);
    setShipToCompanyName(data?.shipToInfo?.companyName);
    setShipToAddress(data?.shipToInfo?.companyAddress);
    setShipToCity(data?.shipToInfo?.city);
    setShipToState(
      data?.shipToInfo?.state ? { stateName: data?.shipToInfo?.state } : ''
    );
    setShipToPostCode(data?.shipToInfo?.zipCode);
    setShipToCountry(
      data?.shipToInfo?.country
        ? { countryName: data?.shipToInfo?.country }
        : ''
    );
    setSelectedShippingCharge(
      data?.shippingCharges
        ? i18n.language === 'fr'
          ? 'Oui'
          : 'Yes'
        : i18n.language === 'fr'
          ? 'Non'
          : 'No'
    );
    setSelectedShippingCalculation(data?.shippingRateType);
    setShippingCharges(data?.shippingRate);

    setSelectedPaymentMethod(
      typeof data?.payment?.method === 'object'
        ? (i18n.language === 'fr' ? data?.payment?.method?.fr : data?.payment?.method?.en)
        : data?.payment?.method
    );

    setSelectedPaymentTerm(
      typeof data?.payment?.terms === 'object'
        ? (i18n.language === 'fr' ? data?.payment?.terms?.fr : data?.payment?.terms?.en)
        : data?.payment?.terms
    );

    setSelectedTaxRate1({ taxName: data?.taxes?.rate1 });
    setSelectedTaxRate2({ taxName: data?.taxes?.rate2 });

    // if (data?.preferredShippingMethod) {
    //   let includes: boolean = PREFERRED_SHIPPING_METHOD_ARRAY?.includes({
    //     id: data?.preferredShippingMethod,
    //     value: data?.preferredShippingMethod
    //   });

    //   if (includes) {
    //     setSelectedPreferredShippingMethod(data?.preferredShippingMethod);
    //   } else {
    //     setSelectedPreferredShippingMethod('Other');
    //   }

    // }

    setSelectedPreferredShippingMethod(
      data?.preferredShippingMethod
        ? { methodName: data?.preferredShippingMethod }
        : null
    );

    setLatestStoreNote(
      data?.storeNotes
        ? data?.storeNotes?.at(data?.storeNotes?.length - 1)?.notes?.toString()
        : t('NO_STORE_NOTES_AVAILABLE')
    );

    setLatestSupplierNote(
      data?.supplierNotes
        ?.at(data?.supplierNotes?.length - 1)
        ?.notes?.toString()
    );

    const orders = data?.products?.map((item: any) => {
      return {
        ...item,
        confirmedQuantity: item?.confirmedQuantity ?? item?.quantity,
        unitPrice: item?.price,
        totalprice: (Number(item?.quantity) * Number(item?.price)).toFixed(2),
        backOrder: data?.backOrder,
      };
    });

    setTotal({
      ...data?.amount,
      // calculatedshippingCharge:
      //   selectedValue !== null && 'shippingRateType' in selectedValue
      //     ? selectedValue['shippingRateType'] === 'Amount'
      //       ? t('TO_BE_CONFIRMED')
      //       : data?.amount?.calculatedshippingCharge
      //     : '',
    });

    const ordersS: any = [];
    data?.subOrders?.forEach((order: any) => {
      ordersS.push({
        orderId: order.orderId,
        status: order.status,
        products: order.products?.map((item: any) => {
          return {
            ...item,
            unitPrice: item?.price,
            totalprice: (Number(item?.quantity) * Number(item?.price)).toFixed(
              2
            ),
          };
        }),
        amount: order.amount,
      });
    });

    setSplitOrders([...ordersS]);
    setOrdersList([...orders]);
  }

  async function productPayload() {
    let payload: any = {
      products: ordersList.map((item: any) => {
        return {
          categoryId: item?.categoryId,
          subCategoryId: item?.subCategoryId,
          productId: item?.productId,
          product_id: item?.product_id,
          quantity: item?.quantity,
          confirmedQuantity: item?.confirmedQuantity && item?.quantity,
          productName: item?.productName,
          _id: item?._id,
          price: item?.price,
          totalPrice: parseFloat(
            (
              parseFloat(item?.confirmedQuantity ?? item?.quantity) *
              parseFloat(item?.price)
            ).toFixed(2)
          ),
          backOrder: item?.backOrder,
        };
      }),
      shipTo: selectedShipTo,
      selectedValue: selectedValue,
    };
    return payload;
  }

  async function updateDetails() {
    let payload = {
      _id: location?.state?.id,
      shipTo: selectedShipTo,
      shipToInfo: {
        name: shipToName,
        companyName: shipToCompanyName,
        companyAddress: shipToAddress,
        city: shipToCity,
        zipCode: shipToPostCode,
        state: shipToState?.stateName,
        country: shipToCountry?.countryName,
      },
    };
    await dispatch(updateStoreDetails(payload));
  }

  async function handleShipToCountrySelect(country: any) {
    setShipToState(null);
    dispatch(clearStatesState());

    if (country === undefined || country === null) {
      setShipToCountry(null);
      return;
    }

    setShipToCountry(country);
    let payload: any = { page: 1, limit: 100, countryId: country?._id };
    await dispatch(fetchStates(payload));
  }

  function openEditOrderDialog(isEdit: any, data: any) {
    return myContext.setDialog({
      open: true,
      title: 'EditOrder',
      dialogContent: {
        pageName: 'EditOrder',
        params: {
          isEdit,
          data,
          _id: location?.state?.id,
          selectedTaxRate1,
          selectedTaxRate2,
          selectedShippingCalculation,
          shippingCharges,
        },
        onBack: async () => {},
      },
    });
  }

  function openShippedOrderDialog(isEdit: any, data: any) {
    return myContext.setDialog({
      open: true,
      title: 'ShippedOrder',
      dialogContent: {
        pageName: 'ShippedOrder',
        params: { isEdit, data, _id: location?.state?.id },
        onBack: async () => {},
      },
    });
  }

  function getMenus() {
    let processAllButton: any = (
      <BakeasyButton
        fullWidth={false}
        className="tableOption"
        label={t('PROCESS_ALL')}
        onClick={async function (
          event: React.MouseEvent<HTMLButtonElement, MouseEvent>
        ): Promise<void> {
          await dispatch(
            modifyOrderStatus({ id: location?.state?.id, status: 'Processed' })
          );
          dispatch(clearOrdersState());
          navigate(-1);
        }}
      />
    );

    let cancelButton: any = (
      <BakeasyButton
        color="error"
        fullWidth={false}
        label={t('CANCEL_ORDER')}
        className="tableOption"
        onClick={async function (
          event: React.MouseEvent<HTMLButtonElement, MouseEvent>
        ): Promise<void> {
          await dispatch(cancelOrder({ id: location?.state?.id }));
          dispatch(clearOrdersState());
          navigate(-1);
        }}
      />
    );
    let printButton: any = (
      <BakeasyButton
        label={t('PRINT')}
        className="tableOption"
        onClick={function (
          event: React.MouseEvent<HTMLButtonElement, MouseEvent>
        ): void {
          dispatch(
            downloadOrderDetails({
              id: location?.state?.id,
              downloadType: 'pdf',
            })
          );
        }}
      />
    );

    return (
      <Grid>
        {status === 'New' && (
          <div className="tableOptions">
            <BakeasyButton
              fullWidth={false}
              label={t('KEEP_AS_NEW')}
              className="tableOption"
              onClick={function (
                event: React.MouseEvent<HTMLButtonElement, MouseEvent>
              ): void {
                navigate(-1);
              }}
            />
            {processAllButton}
            <BakeasyButton
              fullWidth={false}
              label={t('EDIT_ORDER')}
              className="tableOption"
              onClick={async function (
                event: React.MouseEvent<HTMLButtonElement, MouseEvent>
              ): Promise<void> {
                let payload = await productPayload();
                openEditOrderDialog(false, payload);
              }}
            />
            {cancelButton}
            {printButton}
          </div>
        )}
        {status === 'Processed' && (
          <div className="tableOptions">
            {cancelButton}
            {printButton}
          </div>
        )}
        {status === 'Split' && (
          <div className="tableOptions">{printButton}</div>
        )}
        {status === 'Cancelled' && (
          <div className="tableOptions">{printButton}</div>
        )}
        {status === 'Complete' && (
          <div className="tableOptions">{printButton}</div>
        )}

        {status === 'Backorder' && (
          <div className="tableOptions">
            {processAllButton}
            {cancelButton}
            {printButton}
          </div>
        )}
        {status === 'InProduction' && (
          <div className="tableOptions">
            <BakeasyButton
              fullWidth={false}
              className="tableOption"
              label={t('PACKED')}
              onClick={async function (
                event: React.MouseEvent<HTMLButtonElement, MouseEvent>
              ): Promise<void> {
                await dispatch(packedOrder({ id: location?.state?.id }));
                dispatch(clearOrdersState());
                navigate(-1);
              }}
            />
            <BakeasyButton
              fullWidth={false}
              className="tableOption"
              label={t('PACKED_AND_SHIPPING')}
              onClick={async function (
                event: React.MouseEvent<HTMLButtonElement, MouseEvent>
              ): Promise<void> {
                let payload = await productPayload();
                openShippedOrderDialog(false, payload);
              }}
            />
            {printButton}
          </div>
        )}
        {status === 'Packed' && (
          <div className="tableOptions">
            <BakeasyButton
              fullWidth={false}
              className="tableOption"
              label={t('PACKED_AND_SHIPPING')}
              onClick={async function (
                event: React.MouseEvent<HTMLButtonElement, MouseEvent>
              ): Promise<void> {
                let payload = await productPayload();
                openShippedOrderDialog(false, payload);
              }}
            />
            {printButton}
          </div>
        )}
        {/* {status === 'Shipped' && (
          <div className="tableOptions">
            <BakeasyButton
              fullWidth={false}
              className="tableOption"
              label={t('CreateInvoice')}
              onClick={function(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void {}}
            />
          </div>
        )} */}
        {/* <div className="tableOptions">
          <BakeasyButton
            label={t('PRINT')}
            className="tableOption"
            onClick={function(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void {
              dispatch(downloadOrderDetails({ id: location?.state?.id, downloadType: 'pdf' }));
            }}
          />
        </div> */}
      </Grid>
    );
  }

  function orderDetailsUI() {
    return (
      <Grid>
        <Grid item>
          <BakeasyAppBar
            title={t('ORDER_DETAILS')}
            onBackClick={() => {
              navigate(-1);
            }}
            menus={
              // <Button.Print
              //   onClick={function (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void {
              //     dispatch(downloadOrderDetails({ id: location?.state?.id, downloadType: 'pdf' }));
              //   }}

              // />
              getMenus()
            }
          />
        </Grid>
        <Paper component={Card} variant="outlined" sx={{ p: 2, mt: 1 }}>
          <Grid container>
            <Grid item xs={12} sm={12}>
              <BakeasyLargeHeadingValue
                heading={t('ORDER_ID')}
                value={orderId}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <BakeasyLargeHeadingStatus
                heading={t('ORDER_STATUS')}
                value={<BakeasyChip label={status} />}
              />
            </Grid>
          </Grid>
          <Grid container mt={1}>
            <BakeasyHeaderLabel message="ORDER_DETAILS" />
          </Grid>

          <Grid container spacing={2} pl={2}>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                disabled={true}
                label={t('SUPPLIER_NAME')}
                value={supplierName}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                required={true}
                label={t('ORDER_BY')}
                disabled={true}
                type="text"
                name=""
                value={orderBy}
                maxLength={10}
                onChange={function (event: any): void {
                  setOrderBy(event?.target?.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                required={true}
                label={t('STORE_PO_NUMBER')}
                disabled={true}
                type="text"
                value={poNumber}
                maxLength={10}
                onChange={(event: any) => {
                  setPoNumber(event?.target?.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyDatePicker
                label={t('REQUESTED_DELIVERY_DATE')}
                disabled={false}
                value={dayjs(requestedDeliveryDate)}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Dropdown.YesNo
                label={'HIGH_PRIORITY'}
                disabled={true}
                value={selectedPriority}
                onChange={(event: any) => {
                  setSelectedPriority(event?.target?.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                disabled={true}
                label={t('NOTE')}
                placeHolder={t('ENTER_NOTE')}
                type="text"
                name="description"
                value={note}
                multiline
                rows={2}
                onChange={(event: any) => {
                  setNote(event.target.value);
                }}
                required={true}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              xl={3}
              sx={{ marginTop: 1 }}
            >
              <BakeasyNotesLabelText
                label={t('SUPPLIER_NOTES')}
                value={latestSupplierNote}
                maxLength={800}
              />
              <BakeasyLinkButton
                style={{ fontSize: '0.9rem' }}
                label={t('VIEW_ALL')}
                onClick={() => {
                  openSupplierNotesDialog(
                    false,
                    'orderDetails',
                    fetchOrderById
                  );
                }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              xl={3}
              sx={{ marginTop: 1 }}
            >
              <BakeasyNotesLabelText
                label={t('STORE_NOTES')}
                value={latestStoreNote}
                maxLength={800}
              />
              <BakeasyLinkButton
                style={{ fontSize: '0.9rem' }}
                label={t('VIEW_ALL')}
                onClick={() => {
                  if (latestStoreNote === undefined) {
                    dispatch(
                      showErrorSnackbar({
                        message: t('NO_STORE_NOTES_AVAILABLE'),
                      })
                    );
                    return;
                  }
                  openStoreNotesDialog(false, 'orderDetails');
                }}
              />
            </Grid>
          </Grid>
          <BakeasyDivider />

          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <BakeasyHeaderLabel message={t('SHIPPING_DETAILS')} />
            </Grid>

            {status !== 'Cancelled' && status !== 'Split' && (
              <>
                {/* {selectedValue && selectedValue['shipTo'] !== selectedValue['storeInfo']?.['shipTo'] && ( */}
                <Grid item sx={{ mb: 0.5 }}>
                  <Typography style={{ fontSize: '0.75rem', color: RED_400 }}>
                    {t('DEFAULT_SHIP_TO')}
                  </Typography>
                </Grid>
                {/* )} */}

                <Grid
                  xs="auto"
                  sx={{
                    marginLeft: 'auto',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <BakeasyButtonUpdateShipping
                    size={'small'}
                    onClick={() => {
                      updateDetails();
                    }}
                  />
                </Grid>
              </>
            )}
          </Grid>

          <Grid container spacing={2} pl={2}>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Dropdown.ShipTo
                disabled={isView || status === 'Cancelled' || status === 'Split'}
                value={selectedShipTo}
                onChange={(event: any) => {
                  setSelectedShipTo(event.target.value);
                  setShipToData(event?.target?.value, selectedValue);
                }}
                required={true}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.Name
                disabled={isView || status === 'Cancelled' || status === 'Split'}
                value={shipToName}
                placeHolder={t('ENTER_NAME')}
                required={true}
                onChange={(event: any) => {
                  setShipToName(event.target.value);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.Name
                disabled={isView || status === 'Cancelled' || status === 'Split'}
                label={t('COMPANY_NAME')}
                placeHolder={t('ENTER_COMPANY_NAME')}
                required={true}
                value={shipToCompanyName}
                onChange={(event: any) => {
                  setShipToCompanyName(event.target.value);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyAutoCompleteCountry
                label={'COUNTRY'}
                required={true}
                disabled={isView || status === 'Cancelled' || status === 'Split'}
                value={shipToCountry}
                options={_countryState.value?.data}
                onChange={(newValue: any) => {
                  // if (typeof newValue === 'string' && newValue?.length === 0) {
                  //   dispatch(fetchCountries({ page: 1, limit: 5 }));
                  // }

                  // if (typeof newValue === 'string' && newValue?.length > 2) {
                  //   dispatch(fetchCountries({ page: 1, limit: 5, search: newValue }));
                  // }

                  if (typeof newValue === 'object') {
                    handleShipToCountrySelect(newValue);
                    setShipToPostCode('');
                  }

                  if (newValue === null) {
                    setShipToCountry(null);
                    setShipToPostCode('');
                    //dispatch(fetchCountries({ page: 1, limit: 5 }));
                  }
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyAutoCompleteState
                label={t('STATE_PROVINCE')}
                required={true}
                disabled={isView || status === 'Cancelled' || status === 'Split' || shipToCountry === null}
                //disabled={true}
                value={shipToState}
                options={_statesState.value?.data}
                onChange={async (newValue: any) => {
                  if (typeof newValue === 'object') {
                    setShipToState(newValue);
                  }
                  if (newValue === null) {
                    setShipToState(null);
                  }
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.City
                disabled={isView || status === 'Cancelled' || status === 'Split'}
                value={shipToCity}
                onChange={(event: any) => {
                  setShipToCity(event.target.value);
                }}
                placeHolder={t('ENTER_CITY')}
                required={true}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.Address
                disabled={isView || status === 'Cancelled' || status === 'Split'}
                label={t('COMPANY_ADDRESS')}
                value={shipToAddress}
                onChange={(event: any) => {
                  setShipToAddress(event.target.value);
                }}
                placeHolder={t('ENTER_COMPANY_ADDRESS')}
                required={true}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.Pincode
                disabled={isView || status === 'Cancelled' || status === 'Split'}
                value={shipToPostCode}
                placeHolder={t('ENTER_POSTAL_CODE')}
                required={true}
                // onChange={(event: any) => {
                //   setShipToPostCode(preparePostalCode(event.target.value));
                // }}
                maxLength={getMaxLengthForPostalCode(
                  shipToCountry?.countryName
                )}
                regexPattern={getRegexPatternForPostalCode(
                  shipToCountry?.countryName
                )}
                onChange={(event: any) => {
                  setShipToPostCode(
                    preparePostalCode(
                      event.target.value,
                      shipToCountry?.countryName
                    )
                  );
                }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} pl={2} mt={0}>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Dropdown.YesNo
                disabled={true}
                label={t('SHIPPING_CHARGE')}
                value={selectedShippingCharge}
                onChange={function (event: any): void {
                  setSelectedShippingCharge(event?.target?.value);
                  setSelectedShippingCalculation('');
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Dropdown.ShippingCalculation
                disabled={true}
                value={selectedShippingCalculation}
                onChange={(event: any) => {
                  setSelectedShippingCalculation(event?.target?.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.Number
                label={t('SHIPPING_CHARGES')}
                maxLength={4}
                disabled={true}
                value={shippingCharges}
                onChange={(event: any) => {
                  setShippingCharges(event.target.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyAutoCompleteShippingMethod
                disabled={true}
                required={false}
                value={selectedPreferredShippingMethod}
                options={
                  _shippingMethodsState.value?.data?.length > 0
                    ? _shippingMethodsState.value?.data
                    : null
                }
                onAddClick={(props: any) => {
                  //openAddShippingMethodDialog(props);
                }}
                onChange={(newValue: any) => {
                  // if (typeof newValue === 'string' && newValue?.length > 2) {
                  //   dispatch(fetchShippingMethods({ page: 1, limit: 5, search: newValue }));
                  // }
                  // if (typeof newValue === 'string' && newValue?.length === 0) {
                  //   dispatch(fetchShippingMethods({ page: 1, limit: 5 }));
                  // }
                  // if (typeof newValue === 'object' && newValue?.id !== 0) {
                  //   setSelectedPreferredShippingMethod(newValue);
                  // }
                }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} pl={2} mt={0}>
            {/* <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Dropdown.PreferredShippingMethod
                disabled={true}
                value={selectedPreferredShippingMethod}
                onChange={function(event: any): void {
                  setSelectedPreferredShippingMethod(event?.target?.value);
                  setPreferredShippingMethod(event?.target?.value);
                }}
              />
            </Grid> */}
          </Grid>

          <BakeasyDivider />

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('TAXES')} />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container spacing={2} pl={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    {/* <Dropdown.TaxRateOne
                      disabled={true}
                      value={selectedTaxRate1}
                      onChange={(event: any) => {
                        setSelectedTaxRate1(event.target.value);
                      }}
                    /> */}
                    <BakeasyAutoCompleteTax
                      label="STORE_TAX1"
                      disabled={true}
                      value={selectedTaxRate1}
                      options={
                        _taxesState.value?.data?.length > 0
                          ? _taxesState.value?.data
                          : null
                      }
                      onChange={function (newValue: any): void {
                        // throw new Error('Function not implemented.');
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    {/* <Dropdown.TaxRateTwo
                      disabled={true}
                      value={selectedTaxRate2}
                      onChange={(event: any) => {
                        setSelectedTaxRate2(event.target.value);
                      }}
                    /> */}
                    <BakeasyAutoCompleteTax
                      label="STORE_TAX2"
                      disabled={true}
                      value={selectedTaxRate2}
                      options={
                        _taxesState.value?.data?.length > 0
                          ? _taxesState.value?.data
                          : null
                      }
                      onChange={function (newValue: any): void {
                        // throw new Error('Function not implemented.');
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <TextField.Name
                      disabled={true}
                      label={t('STORE_TAX1_RATE')}
                      value={
                        selectedTaxRate1?.taxName
                          ? selectedTaxRate1?.taxName?.split(' - ', 10).pop()
                          : ''
                      }
                      // onChange={(event: any) => {
                      //   setTaxNumber1(event.target.value);
                      // }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <TextField.Name
                      disabled={true}
                      label={t('STORE_TAX2_RATE')}
                      value={
                        selectedTaxRate2?.taxName
                          ? selectedTaxRate2?.taxName?.split(' - ', 10).pop()
                          : ''
                      }
                      // onChange={(event: any) => {
                      //   setTaxNumber2(event.target.value);
                      // }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('PAYMENT')} />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container spacing={2} pl={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Dropdown.PaymentMethod
                      disabled={true}
                      value={selectedPaymentMethod}
                      onChange={(event: any) => {
                        setSelectedPaymentMethod(event.target.value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Dropdown.PaymentTerms
                      disabled={true}
                      value={selectedPaymentTerm}
                      onChange={(event: any) => {
                        setSelectedPaymentTerm(event.target.value);
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {ordersList?.length > 0 && (
            <>
              <BakeasyDivider />
              <Grid item xs={12} sx={{ p: 1 }}>
                <BakeasySimpleTable
                  headers={orderDetailsTableHeaders}
                  tableData={ordersList}
                  status={status}
                  orderValue={selectedValue}
                  type={'orderDetails'}
                  data={total}
                />
              </Grid>
            </>
          )}

          {status === 'Split' &&
            splitOrders?.length > 0 &&
            splitOrders?.map((order: any) => {
              return (
                <>
                  <BakeasyDivider />
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
                    <Grid
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <BakeasyHeaderLabel message={`${order?.orderId}`} />
                      {/* <BakeasyChip label={`Status:${order?.status}`} /> */}
                      <BakeasyChip label={order?.status} />
                    </Grid>
                  </Grid>

                  <Grid>
                    {order?.products?.length > 0 ? (
                      <BakeasySimpleTable
                        headers={orderDetailsTableHeaders}
                        tableData={order?.products}
                        status={order?.status}
                        type={'orderDetails'}
                        orderValue={selectedValue}
                        data={{
                          ...order?.amount,
                          // calculatedshippingCharge:
                          //   selectedValue !== null &&
                          //   'shippingRateType' in selectedValue
                          //     ? selectedValue['shippingRateType'] === 'Amount'
                          //       ? t('TO_BE_CONFIRMED')
                          //       : order?.amount?.calculatedshippingCharge
                          //     : '',
                        }}
                      />
                    ) : (
                      <BakeasyEmptyMsg message={t('NO_DATA_FOUND')} />
                    )}
                  </Grid>
                </>
              );
            })}

          <BakeasyDivider />
        </Paper>
      </Grid>
    );
  }
  return orderDetailsUI();
};
